import './Aside.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import { ITEM_TYPES, ROLES } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import { ReactComponent as ScanIcon } from '@/ebat/assets/icons/scan.svg';
import Total from '@/ebat/components/blocks/Aside/Total/Total';
import Worksite from '@/ebat/components/blocks/Aside/Worksite/Worksite';
import Promotions from '@/ebat/components/blocks/Cart/Promotions/Promotions';

import { AsideDefaultProps, AsidePropTypes } from './Aside.proptypes';
import useAside from './useAside';

const Aside = ({
  cart,
  className,
  disabled,
  isLoading,
  isUpdated,
  onScanBarCode,
  refetchCart,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const { isDisabled } = useAside({
    disabled,
    isLoading,
  });

  return (
    <div className={cn('scanbat-aside', className)}>
      <h1 className="h1 scanbat-aside__title" data-qa-id="title-h1">
        {t('ebat:entities:scanbat.cart.title')}
      </h1>
      <div
        className={cn('scanbat-aside__infos', {
          guest: user?.role === ROLES.CUSTOMER_GUEST,
        })}
      >
        {user?.role !== ROLES.CUSTOMER_GUEST && (
          <Total isUpdated={isUpdated} subtotal={cart.subtotal} />
        )}

        {user?.role === ROLES.CUSTOMER_GUEST && (
          <Total
            isUpdated={isUpdated}
            subtotal={cart.subtotal_incl_vat}
            type="TTC"
          />
        )}
        {user?.role !== ROLES.CUSTOMER_GUEST && (
          <Worksite
            disabled={isDisabled.worksite}
            entity={cart}
            isLoading={isDisabled.loading}
            onSuccess={refetchCart}
            type={ITEM_TYPES.cart}
          />
        )}
      </div>
      <Promotions
        className="scanbat-aside__promotions"
        discountClasses={cart.discount_classes}
        isUpdated={isUpdated}
      />
      <Button
        buttonSize="large"
        className="scanbat-aside__scan"
        disabled={isDisabled.scandit}
        onClick={onScanBarCode}
        variant="primary-light"
      >
        <ScanIcon className="button__icon" />
        {t('ebat:messages:actions.scan_item')}
      </Button>
    </div>
  );
};

Aside.defaultProps = {
  ...AsideDefaultProps,
};

Aside.propTypes = {
  ...AsidePropTypes,
};

export default Aside;
